import React, { useEffect, useState } from 'react';
import ComponentToPrintOne from '../ListDetailOder/printComponentOne';
import { get } from '../../helpers/api_helper';
import { useParams } from 'react-router';
const PrintExternalBillById = () => {
  const [orderData, setOrderData] = useState(null);
  const { billId } = useParams();
  useEffect(() => {
    if (!billId) return;
    get(`/bills/bill-scan-inventory/${billId}`)
      .then((res) => {
        const order = res.data.bill;
        order.createdAt = res.createdAt;
        setOrderData(order);
      })
  }, [billId]);

  useEffect(() => {
    if (!orderData) return;
    window.print();
  }, [orderData])

  if (!orderData) return <div>Loading...</div>;
  return (
    <div>
      <ComponentToPrintOne
        {
        ...orderData
        }
        province={""}
        ward={""}
        street={orderData?.addressDeliver}
        listProduct={orderData?.BillDetails}
      />
    </div>
  );
};

export default PrintExternalBillById;